import { __decorate, __metadata } from '../../../../../node_modules/.pnpm/tslib@2.4.1/node_modules/tslib/tslib.es6.js';
import { action, computed, makeObservable, observable, toJS, runInAction } from 'mobx';
import { ApiItemType, ApiErrorResponseFromJSON } from '@ibe/api';
import LoggerFactory from '../../Util/Logger/LoggerFactory.js';
import clone from '../../Util/clone.js';
import { bookingInitEvent } from '../../Events/commonEvents.js';
import MaskBookingService from './MaskBookingService.js';
import Headers from '../../Util/Headers.js';
import { AnalyticsService } from '../Analytics/AnalyticsService.js';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* *
 *
 * BookingService is meant to manage one single booking
 *
 *       1:n         1:n
 *  User --> Booking --> Item
 *
 *  Booking == ShoppingCart
 *
 * */
var BookingService = /*#__PURE__*/function () {
  function BookingService() {
    _classCallCheck(this, BookingService);
    this.logger = LoggerFactory.get('BookingService');
    this.ERR_NO_API = 'Can not init booking: No API instance.';
    this.api = null;
    this.authService = null;
    this.isBusyValue = true;
    this.hasErrorValue = false;
    this.bookingValue = null;
    this._seatMaps = undefined;
    this._selectablePackageOffers = void 0;
    this._travelerComponentsAssociations = void 0;
    this._components = void 0;
    this._packageCart = undefined;
    this.errorResponse = null;
    makeObservable(this, {
      isBusyValue: observable,
      hasErrorValue: observable,
      bookingValue: observable,
      _travelerComponentsAssociations: observable,
      _components: observable,
      _selectablePackageOffers: observable,
      _packageCart: observable,
      errorResponse: observable,
      _seatMaps: observable,
      executeBookingAttempt: action,
      booking: computed,
      bookedItems: computed,
      discounts: computed,
      isBusy: computed,
      hasError: computed,
      init: action,
      addItem: action,
      addItems: action,
      removeItem: action,
      removeItems: action,
      doAttemptBooking: action,
      submitDiscount: action,
      doBooking: action,
      updateTravelerAssignment: action,
      updateCustomer: action,
      updateAffiliate: action,
      updateBookingItemSpecialRequest: action,
      addBestPricePackageToBooking: action,
      applyPaxRoomAssignments: action,
      addPromoCodesToBooking: action,
      addTraveler: action,
      updateTraveler: action,
      updateTravelers: action,
      removeTraveler: action,
      apiCall: action,
      apiCallWithBooking: action,
      getHotels: action,
      loadSeatMaps: action,
      loadSeatMap: action,
      loadPackageCart: action,
      selectItemsInPackageCart: action,
      updatePackageCartBooking: action,
      removeItemFromPackageCart: action,
      updateBusStations: action,
      removeItemsFromPackageCart: action,
      reloadComponents: action,
      cleanInvalidDiscounts: action
    });
  }
  _createClass(BookingService, [{
    key: "setApi",
    value: function setApi(api) {
      this.api = api;
    }
  }, {
    key: "setAuth",
    value: function setAuth(auth) {
      this.authService = auth;
    }
  }, {
    key: "setNewBooking",
    value: function setNewBooking(booking) {
      this.bookingValue = booking;
    }
  }, {
    key: "clearBooking",
    value: function clearBooking() {
      this.bookingValue = null;
    }
  }, {
    key: "cleanInvalidDiscounts",
    value: function cleanInvalidDiscounts() {
      var _this$bookingValue, _this$bookingValue2;
      if ((_this$bookingValue = this.bookingValue) !== null && _this$bookingValue !== void 0 && _this$bookingValue.discounts && ((_this$bookingValue2 = this.bookingValue) === null || _this$bookingValue2 === void 0 ? void 0 : _this$bookingValue2.discounts.length) > 0) {
        this.bookingValue.discounts = this.bookingValue.discounts.filter(function (discount) {
          return !discount.isInvalidated;
        });
      }
    }
  }, {
    key: "executeBookingAttempt",
    value: function () {
      var _executeBookingAttempt = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.api) {
                _context.next = 2;
                break;
              }
              throw new Error(this.ERR_NO_API);
            case 2:
              this.errorResponse = null;
              if (!(this.booking && this.booking.bookedItems.length === 0)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", Promise.resolve());
            case 5:
              if (!this.booking) {
                _context.next = 31;
                break;
              }
              this.isBusyValue = true;
              _context.prev = 7;
              _context.next = 10;
              return this.api.doAttemptBooking(this.booking.id);
            case 10:
              this.bookingValue = _context.sent;
              this.isBusyValue = false;
              return _context.abrupt("return", Promise.resolve());
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](7);
              _context.prev = 17;
              this.hasErrorValue = true;
              _context.t1 = ApiErrorResponseFromJSON;
              _context.next = 22;
              return _context.t0.json();
            case 22:
              _context.t2 = _context.sent;
              this.errorResponse = (0, _context.t1)(_context.t2);
              _context.next = 29;
              break;
            case 26:
              _context.prev = 26;
              _context.t3 = _context["catch"](17);
              this.logger.error(_context.t3);
            case 29:
              this.isBusyValue = false;
              return _context.abrupt("return", Promise.reject(_context.t0));
            case 31:
              return _context.abrupt("return", Promise.reject());
            case 32:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[7, 15], [17, 26]]);
      }));
      function executeBookingAttempt() {
        return _executeBookingAttempt.apply(this, arguments);
      }
      return executeBookingAttempt;
    }()
  }, {
    key: "booking",
    get: function get() {
      return this.bookingValue ? clone(this.bookingValue) : null;
    }
  }, {
    key: "bookedItems",
    get: function get() {
      var _this$bookingValue3, _this$bookingValue4;
      return (_this$bookingValue3 = this.bookingValue) !== null && _this$bookingValue3 !== void 0 && _this$bookingValue3.bookedItems ? clone((_this$bookingValue4 = this.bookingValue) === null || _this$bookingValue4 === void 0 ? void 0 : _this$bookingValue4.bookedItems) : null;
    }
  }, {
    key: "discounts",
    get: function get() {
      var _this$bookingValue5, _this$bookingValue6;
      return (_this$bookingValue5 = this.bookingValue) !== null && _this$bookingValue5 !== void 0 && _this$bookingValue5.discounts ? clone((_this$bookingValue6 = this.bookingValue) === null || _this$bookingValue6 === void 0 ? void 0 : _this$bookingValue6.discounts) : undefined;
    }
  }, {
    key: "isBusy",
    get: function get() {
      return this.isBusyValue;
    }
  }, {
    key: "hasError",
    get: function get() {
      return this.hasErrorValue;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(bookingId, throwError, packageId, packageCartId) {
        var _this = this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.apiCall(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(api) {
                  var _this$_packageCart, _this$_packageCart2, response, token;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!bookingId) {
                          _context2.next = 32;
                          break;
                        }
                        if (!(packageId && packageCartId)) {
                          _context2.next = 15;
                          break;
                        }
                        _context2.prev = 2;
                        _context2.next = 5;
                        return _this.loadPackageCart(packageCartId);
                      case 5:
                        _context2.next = 7;
                        return api.getBooking(bookingId);
                      case 7:
                        _this.bookingValue = _context2.sent;
                        _context2.next = 13;
                        break;
                      case 10:
                        _context2.prev = 10;
                        _context2.t0 = _context2["catch"](2);
                        throw new Error(_context2.t0);
                      case 13:
                        _context2.next = 30;
                        break;
                      case 15:
                        if (!packageId) {
                          _context2.next = 26;
                          break;
                        }
                        _context2.prev = 16;
                        _context2.next = 19;
                        return _this.initPackageCart(packageId, bookingId, packageCartId);
                      case 19:
                        _context2.next = 24;
                        break;
                      case 21:
                        _context2.prev = 21;
                        _context2.t1 = _context2["catch"](16);
                        throw new Error(_context2.t1);
                      case 24:
                        _context2.next = 30;
                        break;
                      case 26:
                        _context2.next = 28;
                        return api.getBooking(bookingId);
                      case 28:
                        _this.bookingValue = _context2.sent;
                        _this.logger.log('getBooking', toJS(_this.bookingValue));
                      case 30:
                        _context2.next = 67;
                        break;
                      case 32:
                        if (!packageId) {
                          _context2.next = 52;
                          break;
                        }
                        _context2.prev = 33;
                        _context2.next = 36;
                        return _this.initPackageCart(packageId, 'EMPTY', packageCartId);
                      case 36:
                        if (!((_this$_packageCart = _this._packageCart) !== null && _this$_packageCart !== void 0 && _this$_packageCart.bookingId)) {
                          _context2.next = 42;
                          break;
                        }
                        _context2.next = 39;
                        return api.getBooking((_this$_packageCart2 = _this._packageCart) === null || _this$_packageCart2 === void 0 ? void 0 : _this$_packageCart2.bookingId);
                      case 39:
                        _this.bookingValue = _context2.sent;
                        _context2.next = 45;
                        break;
                      case 42:
                        _context2.next = 44;
                        return api.initBooking();
                      case 44:
                        _this.bookingValue = _context2.sent;
                      case 45:
                        _context2.next = 50;
                        break;
                      case 47:
                        _context2.prev = 47;
                        _context2.t2 = _context2["catch"](33);
                        throw new Error(_context2.t2);
                      case 50:
                        _context2.next = 66;
                        break;
                      case 52:
                        if (!_this.authService) {
                          _context2.next = 63;
                          break;
                        }
                        _context2.next = 55;
                        return api.initBookingRaw();
                      case 55:
                        response = _context2.sent;
                        token = response.raw.headers.get(Headers.AUTHORIZATION);
                        if (token) {
                          _this.authService.authenticate(token);
                        }
                        _context2.next = 60;
                        return response.value();
                      case 60:
                        _this.bookingValue = _context2.sent;
                        _context2.next = 66;
                        break;
                      case 63:
                        _context2.next = 65;
                        return api.initBooking();
                      case 65:
                        _this.bookingValue = _context2.sent;
                      case 66:
                        _this.logger.log('initBooking', toJS(_this.bookingValue));
                      case 67:
                        bookingInitEvent.broadcast({
                          booking: MaskBookingService.maskBooking(_this.bookingValue),
                          item: null,
                          analytics: AnalyticsService.createAnalyticsObject(_this.bookingValue)
                        });
                      case 68:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, null, [[2, 10], [16, 21], [33, 47]]);
                }));
                return function (_x5) {
                  return _ref.apply(this, arguments);
                };
              }(), throwError);
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function init(_x, _x2, _x3, _x4) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(bookingId) {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!bookingId) {
                _context7.next = 6;
                break;
              }
              _context7.next = 3;
              return this.apiCall(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(api) {
                  var response, token;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!_this2.authService) {
                          _context4.next = 11;
                          break;
                        }
                        _context4.next = 3;
                        return api.reinitBookingRaw({
                          bookingId: bookingId
                        });
                      case 3:
                        response = _context4.sent;
                        token = response.raw.headers.get(Headers.AUTHORIZATION);
                        if (token) {
                          _this2.authService.authenticate(token);
                        }
                        _context4.next = 8;
                        return response.value();
                      case 8:
                        _this2.bookingValue = _context4.sent;
                        _context4.next = 14;
                        break;
                      case 11:
                        _context4.next = 13;
                        return api.reinitBooking(bookingId);
                      case 13:
                        _this2.bookingValue = _context4.sent;
                      case 14:
                        _this2.logger.log('reinitialized booking', toJS(_this2.bookingValue));
                      case 15:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x7) {
                  return _ref2.apply(this, arguments);
                };
              }(), true)["catch"](/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(reject) {
                  var error;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        error = reject;
                        if (!(error.status === 401)) {
                          _context5.next = 4;
                          break;
                        }
                        _context5.next = 4;
                        return _this2.initialize();
                      case 4:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x8) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 3:
              return _context7.abrupt("return", _context7.sent);
            case 6:
              _context7.next = 8;
              return this.apiCall(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(api) {
                  var response, token;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        if (!_this2.authService) {
                          _context6.next = 11;
                          break;
                        }
                        _context6.next = 3;
                        return api.initBookingRaw();
                      case 3:
                        response = _context6.sent;
                        token = response.raw.headers.get(Headers.AUTHORIZATION);
                        if (token) {
                          _this2.authService.authenticate(token);
                        }
                        _context6.next = 8;
                        return response.value();
                      case 8:
                        _this2.bookingValue = _context6.sent;
                        _context6.next = 14;
                        break;
                      case 11:
                        _context6.next = 13;
                        return api.initBooking();
                      case 13:
                        _this2.bookingValue = _context6.sent;
                      case 14:
                        bookingInitEvent.broadcast({
                          booking: MaskBookingService.maskBooking(_this2.bookingValue),
                          item: null,
                          analytics: AnalyticsService.createAnalyticsObject(_this2.bookingValue)
                        });
                        _this2.logger.log('initialized booking', toJS(_this2.bookingValue));
                      case 16:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x9) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 8:
              return _context7.abrupt("return", _context7.sent);
            case 9:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function initialize(_x6) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "addItem",
    value: function () {
      var _addItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(itemId, options, bookingId) {
        var _this3 = this;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(booking, api) {
                  var id;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        if (!booking) {
                          _context8.next = 8;
                          break;
                        }
                        id = bookingId || booking.id;
                        if (!id) {
                          _context8.next = 6;
                          break;
                        }
                        _context8.next = 5;
                        return api.addItemToBooking(id, itemId, options);
                      case 5:
                        _this3.bookingValue = _context8.sent;
                      case 6:
                        _context8.next = 9;
                        break;
                      case 8:
                        _this3.logger.error('booking invalid: ', booking);
                      case 9:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x13, _x14) {
                  return _ref5.apply(this, arguments);
                };
              }(), bookingId);
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function addItem(_x10, _x11, _x12) {
        return _addItem.apply(this, arguments);
      }
      return addItem;
    }()
  }, {
    key: "addItems",
    value: function () {
      var _addItems = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(itemsMap, bookingId) {
        var _this4 = this;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(booking, api) {
                  var id;
                  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        if (!booking) {
                          _context10.next = 8;
                          break;
                        }
                        id = bookingId || booking.id;
                        if (!id) {
                          _context10.next = 6;
                          break;
                        }
                        _context10.next = 5;
                        return api.addItemsToBooking(id, itemsMap);
                      case 5:
                        _this4.bookingValue = _context10.sent;
                      case 6:
                        _context10.next = 9;
                        break;
                      case 8:
                        _this4.logger.error('booking invalid: ', booking);
                      case 9:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee10);
                }));
                return function (_x17, _x18) {
                  return _ref6.apply(this, arguments);
                };
              }(), bookingId);
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function addItems(_x15, _x16) {
        return _addItems.apply(this, arguments);
      }
      return addItems;
    }()
  }, {
    key: "removeItem",
    value: function () {
      var _removeItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(itemId, bookingId) {
        var _this5 = this;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(booking, api) {
                  var id;
                  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                    while (1) switch (_context12.prev = _context12.next) {
                      case 0:
                        if (!booking) {
                          _context12.next = 8;
                          break;
                        }
                        id = bookingId || booking.id;
                        if (!id) {
                          _context12.next = 6;
                          break;
                        }
                        _context12.next = 5;
                        return api.deleteItemFromBooking(id, itemId);
                      case 5:
                        _this5.bookingValue = _context12.sent;
                      case 6:
                        _context12.next = 9;
                        break;
                      case 8:
                        _this5.logger.error('booking invalid: ', booking);
                      case 9:
                      case "end":
                        return _context12.stop();
                    }
                  }, _callee12);
                }));
                return function (_x21, _x22) {
                  return _ref7.apply(this, arguments);
                };
              }(), bookingId);
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function removeItem(_x19, _x20) {
        return _removeItem.apply(this, arguments);
      }
      return removeItem;
    }()
  }, {
    key: "removeItems",
    value: function () {
      var _removeItems = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(itemIds, bookingId) {
        var _this6 = this;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(booking, api) {
                  var id;
                  return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                    while (1) switch (_context14.prev = _context14.next) {
                      case 0:
                        if (!booking) {
                          _context14.next = 8;
                          break;
                        }
                        id = bookingId || booking.id;
                        if (!id) {
                          _context14.next = 6;
                          break;
                        }
                        _context14.next = 5;
                        return api.deleteItemsFromBooking(id, itemIds);
                      case 5:
                        _this6.bookingValue = _context14.sent;
                      case 6:
                        _context14.next = 9;
                        break;
                      case 8:
                        _this6.logger.error('booking invalid: ', booking);
                      case 9:
                      case "end":
                        return _context14.stop();
                    }
                  }, _callee14);
                }));
                return function (_x25, _x26) {
                  return _ref8.apply(this, arguments);
                };
              }(), bookingId);
            case 2:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function removeItems(_x23, _x24) {
        return _removeItems.apply(this, arguments);
      }
      return removeItems;
    }()
  }, {
    key: "doAttemptBooking",
    value: function () {
      var _doAttemptBooking = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var _this7 = this;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(booking, api) {
                  return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                    while (1) switch (_context16.prev = _context16.next) {
                      case 0:
                        if (!(booking && booking.id)) {
                          _context16.next = 7;
                          break;
                        }
                        _this7.logger.log('doAttemptBooking', booking.id);
                        _context16.next = 4;
                        return api.doAttemptBooking(booking.id);
                      case 4:
                        _this7.bookingValue = _context16.sent;
                        _context16.next = 8;
                        break;
                      case 7:
                        _this7.logger.error('booking invalid: ', booking);
                      case 8:
                      case "end":
                        return _context16.stop();
                    }
                  }, _callee16);
                }));
                return function (_x27, _x28) {
                  return _ref9.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function doAttemptBooking() {
        return _doAttemptBooking.apply(this, arguments);
      }
      return doAttemptBooking;
    }()
  }, {
    key: "submitDiscount",
    value: function () {
      var _submitDiscount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19(discountCode) {
        var _this8 = this;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18(booking, api) {
                  return _regeneratorRuntime().wrap(function _callee18$(_context18) {
                    while (1) switch (_context18.prev = _context18.next) {
                      case 0:
                        if (!(booking && booking.id)) {
                          _context18.next = 6;
                          break;
                        }
                        _context18.next = 3;
                        return api.submitDiscount(booking.id, {
                          discountCode: discountCode
                        });
                      case 3:
                        _this8.bookingValue = _context18.sent;
                        _context18.next = 7;
                        break;
                      case 6:
                        _this8.logger.error('booking invalid while trying to submit discount code: ', booking);
                      case 7:
                      case "end":
                        return _context18.stop();
                    }
                  }, _callee18);
                }));
                return function (_x30, _x31) {
                  return _ref10.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function submitDiscount(_x29) {
        return _submitDiscount.apply(this, arguments);
      }
      return submitDiscount;
    }()
  }, {
    key: "doBooking",
    value: function () {
      var _doBooking = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var _this9 = this;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20(booking, api) {
                  return _regeneratorRuntime().wrap(function _callee20$(_context20) {
                    while (1) switch (_context20.prev = _context20.next) {
                      case 0:
                        if (!(booking && booking.id)) {
                          _context20.next = 7;
                          break;
                        }
                        _this9.logger.log('doBooking', booking.id);
                        _context20.next = 4;
                        return api.doBooking(booking.id);
                      case 4:
                        _this9.bookingValue = _context20.sent;
                        _context20.next = 8;
                        break;
                      case 7:
                        _this9.logger.error('booking invalid: ', booking);
                      case 8:
                      case "end":
                        return _context20.stop();
                    }
                  }, _callee20);
                }));
                return function (_x32, _x33) {
                  return _ref11.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function doBooking() {
        return _doBooking.apply(this, arguments);
      }
      return doBooking;
    }()
  }, {
    key: "updateTravelerAssignment",
    value: function () {
      var _updateTravelerAssignment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23(options) {
        var _this10 = this;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22(booking, api) {
                  return _regeneratorRuntime().wrap(function _callee22$(_context22) {
                    while (1) switch (_context22.prev = _context22.next) {
                      case 0:
                        if (!(booking && booking.id)) {
                          _context22.next = 6;
                          break;
                        }
                        _context22.next = 3;
                        return api.updateTravelerAssignment(booking.id, options);
                      case 3:
                        _this10.bookingValue = _context22.sent;
                        _context22.next = 7;
                        break;
                      case 6:
                        _this10.logger.error('booking invalid: ', booking);
                      case 7:
                      case "end":
                        return _context22.stop();
                    }
                  }, _callee22);
                }));
                return function (_x35, _x36) {
                  return _ref12.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function updateTravelerAssignment(_x34) {
        return _updateTravelerAssignment.apply(this, arguments);
      }
      return updateTravelerAssignment;
    }()
  }, {
    key: "updateBookingItemSpecialRequest",
    value: function () {
      var _updateBookingItemSpecialRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25(specialRequests, itemId) {
        var _this11 = this;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24(booking, api) {
                  return _regeneratorRuntime().wrap(function _callee24$(_context24) {
                    while (1) switch (_context24.prev = _context24.next) {
                      case 0:
                        if (!(booking && booking.id)) {
                          _context24.next = 5;
                          break;
                        }
                        _context24.next = 3;
                        return api.updateBookingItemSpecialRequest(booking.id, {
                          itemId: itemId,
                          specialRequests: specialRequests
                        });
                      case 3:
                        _context24.next = 6;
                        break;
                      case 5:
                        _this11.logger.error('update booking special requests failed: ', booking);
                      case 6:
                      case "end":
                        return _context24.stop();
                    }
                  }, _callee24);
                }));
                return function (_x39, _x40) {
                  return _ref13.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function updateBookingItemSpecialRequest(_x37, _x38) {
        return _updateBookingItemSpecialRequest.apply(this, arguments);
      }
      return updateBookingItemSpecialRequest;
    }()
  }, {
    key: "loadSeatMaps",
    value: function () {
      var _loadSeatMaps = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26(itemIds) {
        var _yield$this$api$getSe, _this$api;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _context26.prev = 0;
              _context26.next = 3;
              return (_this$api = this.api) === null || _this$api === void 0 ? void 0 : _this$api.getSeatMaps({
                itemIds: itemIds
              });
            case 3:
              _context26.t1 = _yield$this$api$getSe = _context26.sent;
              _context26.t0 = _context26.t1 === null;
              if (_context26.t0) {
                _context26.next = 7;
                break;
              }
              _context26.t0 = _yield$this$api$getSe === void 0;
            case 7:
              if (!_context26.t0) {
                _context26.next = 11;
                break;
              }
              _context26.t2 = void 0;
              _context26.next = 12;
              break;
            case 11:
              _context26.t2 = _yield$this$api$getSe.seatMaps;
            case 12:
              this._seatMaps = _context26.t2;
              _context26.next = 24;
              break;
            case 15:
              _context26.prev = 15;
              _context26.t3 = _context26["catch"](0);
              this.logger.error(_context26.t3);
              this.hasErrorValue = true;
              _context26.t4 = ApiErrorResponseFromJSON;
              _context26.next = 22;
              return _context26.t3.json();
            case 22:
              _context26.t5 = _context26.sent;
              this.errorResponse = (0, _context26.t4)(_context26.t5);
            case 24:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this, [[0, 15]]);
      }));
      function loadSeatMaps(_x41) {
        return _loadSeatMaps.apply(this, arguments);
      }
      return loadSeatMaps;
    }()
  }, {
    key: "loadSeatMap",
    value: function () {
      var _loadSeatMap = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27(itemId) {
        var _yield$this$api$getSe2, _this$api2, seatMap;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _context27.prev = 0;
              _context27.next = 3;
              return (_this$api2 = this.api) === null || _this$api2 === void 0 ? void 0 : _this$api2.getSeatMap({
                itemId: itemId
              });
            case 3:
              _context27.t1 = _yield$this$api$getSe2 = _context27.sent;
              _context27.t0 = _context27.t1 === null;
              if (_context27.t0) {
                _context27.next = 7;
                break;
              }
              _context27.t0 = _yield$this$api$getSe2 === void 0;
            case 7:
              if (!_context27.t0) {
                _context27.next = 11;
                break;
              }
              _context27.t2 = void 0;
              _context27.next = 12;
              break;
            case 11:
              _context27.t2 = _yield$this$api$getSe2.seatMap;
            case 12:
              seatMap = _context27.t2;
              if (seatMap) {
                this._seatMaps = [seatMap];
              }
              _context27.next = 25;
              break;
            case 16:
              _context27.prev = 16;
              _context27.t3 = _context27["catch"](0);
              this.logger.error(_context27.t3);
              this.hasErrorValue = true;
              _context27.t4 = ApiErrorResponseFromJSON;
              _context27.next = 23;
              return _context27.t3.json();
            case 23:
              _context27.t5 = _context27.sent;
              this.errorResponse = (0, _context27.t4)(_context27.t5);
            case 25:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this, [[0, 16]]);
      }));
      function loadSeatMap(_x42) {
        return _loadSeatMap.apply(this, arguments);
      }
      return loadSeatMap;
    }()
  }, {
    key: "seatMaps",
    get: function get() {
      return this._seatMaps;
    }
  }, {
    key: "updateCustomer",
    value: function () {
      var _updateCustomer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29(request) {
        var _this12 = this;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _context29.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28(booking, api) {
                  return _regeneratorRuntime().wrap(function _callee28$(_context28) {
                    while (1) switch (_context28.prev = _context28.next) {
                      case 0:
                        _this12.logger.log('updateCustomer', request.customer);
                        if (!(booking && booking.id)) {
                          _context28.next = 7;
                          break;
                        }
                        _context28.next = 4;
                        return api.updateCustomer(booking.id, request);
                      case 4:
                        _this12.bookingValue = _context28.sent;
                        _context28.next = 8;
                        break;
                      case 7:
                        _this12.logger.error('booking invalid: ', booking);
                      case 8:
                      case "end":
                        return _context28.stop();
                    }
                  }, _callee28);
                }));
                return function (_x44, _x45) {
                  return _ref14.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
      function updateCustomer(_x43) {
        return _updateCustomer.apply(this, arguments);
      }
      return updateCustomer;
    }()
  }, {
    key: "updateAffiliate",
    value: function () {
      var _updateAffiliate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee31(request) {
        var _this13 = this;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref15 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee30(booking, api) {
                  return _regeneratorRuntime().wrap(function _callee30$(_context30) {
                    while (1) switch (_context30.prev = _context30.next) {
                      case 0:
                        _this13.logger.log('updateAffiliate', request.affiliateNumber);
                        if (!(booking && booking.id)) {
                          _context30.next = 7;
                          break;
                        }
                        _context30.next = 4;
                        return api.updateAffiliate(booking.id, request);
                      case 4:
                        _this13.bookingValue = _context30.sent;
                        _context30.next = 8;
                        break;
                      case 7:
                        _this13.logger.error('booking invalid: ', booking);
                      case 8:
                      case "end":
                        return _context30.stop();
                    }
                  }, _callee30);
                }));
                return function (_x47, _x48) {
                  return _ref15.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this);
      }));
      function updateAffiliate(_x46) {
        return _updateAffiliate.apply(this, arguments);
      }
      return updateAffiliate;
    }()
  }, {
    key: "addTraveler",
    value: function () {
      var _addTraveler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee33(traveler) {
        var _this14 = this;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _context33.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref16 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee32(booking, api) {
                  return _regeneratorRuntime().wrap(function _callee32$(_context32) {
                    while (1) switch (_context32.prev = _context32.next) {
                      case 0:
                        _this14.logger.log('addTraveler', traveler);
                        if (!(booking && booking.id)) {
                          _context32.next = 7;
                          break;
                        }
                        _context32.next = 4;
                        return api.addTraveler(booking.id, false, traveler);
                      case 4:
                        _this14.bookingValue = _context32.sent;
                        _context32.next = 8;
                        break;
                      case 7:
                        _this14.logger.error('booking invalid: ', booking);
                      case 8:
                      case "end":
                        return _context32.stop();
                    }
                  }, _callee32);
                }));
                return function (_x50, _x51) {
                  return _ref16.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
      function addTraveler(_x49) {
        return _addTraveler.apply(this, arguments);
      }
      return addTraveler;
    }()
  }, {
    key: "addPromoCodesToBooking",
    value: function () {
      var _addPromoCodesToBooking = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee35(promoCodes) {
        var _this15 = this;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _context35.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref17 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee34(booking, api) {
                  return _regeneratorRuntime().wrap(function _callee34$(_context34) {
                    while (1) switch (_context34.prev = _context34.next) {
                      case 0:
                        if (!(booking && booking.id)) {
                          _context34.next = 6;
                          break;
                        }
                        _context34.next = 3;
                        return api.addPromoCodes(booking.id, promoCodes);
                      case 3:
                        _this15.bookingValue = _context34.sent;
                        _context34.next = 7;
                        break;
                      case 6:
                        _this15.logger.error('booking invalid: ', booking);
                      case 7:
                      case "end":
                        return _context34.stop();
                    }
                  }, _callee34);
                }));
                return function (_x53, _x54) {
                  return _ref17.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this);
      }));
      function addPromoCodesToBooking(_x52) {
        return _addPromoCodesToBooking.apply(this, arguments);
      }
      return addPromoCodesToBooking;
    }()
  }, {
    key: "addBestPricePackageToBooking",
    value: function () {
      var _addBestPricePackageToBooking = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee37(packageModelId, packageDetailId) {
        var _this16 = this;
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              _context37.prev = 0;
              _context37.next = 3;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref18 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee36(booking, api) {
                  return _regeneratorRuntime().wrap(function _callee36$(_context36) {
                    while (1) switch (_context36.prev = _context36.next) {
                      case 0:
                        if (!(booking && booking.id)) {
                          _context36.next = 6;
                          break;
                        }
                        _context36.next = 3;
                        return api.addBestPricePackageToBooking(packageModelId, packageDetailId, booking.id);
                      case 3:
                        _this16.bookingValue = _context36.sent;
                        _context36.next = 7;
                        break;
                      case 6:
                        _this16.logger.error('booking invalid: ', booking);
                      case 7:
                      case "end":
                        return _context36.stop();
                    }
                  }, _callee36);
                }));
                return function (_x57, _x58) {
                  return _ref18.apply(this, arguments);
                };
              }());
            case 3:
              _context37.next = 9;
              break;
            case 5:
              _context37.prev = 5;
              _context37.t0 = _context37["catch"](0);
              this.hasErrorValue = true;
              return _context37.abrupt("return", Promise.resolve());
            case 9:
            case "end":
              return _context37.stop();
          }
        }, _callee37, this, [[0, 5]]);
      }));
      function addBestPricePackageToBooking(_x55, _x56) {
        return _addBestPricePackageToBooking.apply(this, arguments);
      }
      return addBestPricePackageToBooking;
    }()
  }, {
    key: "applyPaxRoomAssignments",
    value: function () {
      var _applyPaxRoomAssignments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee39(components) {
        var _this17 = this;
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              _context39.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref19 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee38(booking, api) {
                  var res;
                  return _regeneratorRuntime().wrap(function _callee38$(_context38) {
                    while (1) switch (_context38.prev = _context38.next) {
                      case 0:
                        _this17.logger.log('updateTravelers', components);
                        if (!(booking && booking.id)) {
                          _context38.next = 8;
                          break;
                        }
                        _context38.next = 4;
                        return api.applyPaxRoomAssignments(booking.id, {
                          components: components
                        });
                      case 4:
                        res = _context38.sent;
                        _this17.bookingValue = res.booking;
                        _context38.next = 9;
                        break;
                      case 8:
                        _this17.logger.error('booking invalid: ', booking);
                      case 9:
                      case "end":
                        return _context38.stop();
                    }
                  }, _callee38);
                }));
                return function (_x60, _x61) {
                  return _ref19.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context39.stop();
          }
        }, _callee39, this);
      }));
      function applyPaxRoomAssignments(_x59) {
        return _applyPaxRoomAssignments.apply(this, arguments);
      }
      return applyPaxRoomAssignments;
    }()
  }, {
    key: "updateTraveler",
    value: function () {
      var _updateTraveler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee41(traveler) {
        var _this18 = this;
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              _context41.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref20 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee40(booking, api) {
                  return _regeneratorRuntime().wrap(function _callee40$(_context40) {
                    while (1) switch (_context40.prev = _context40.next) {
                      case 0:
                        _this18.logger.log('updateTraveler', traveler);
                        if (!(booking && booking.id)) {
                          _context40.next = 7;
                          break;
                        }
                        _context40.next = 4;
                        return api.updateTraveler(booking.id, false, traveler);
                      case 4:
                        _this18.bookingValue = _context40.sent;
                        _context40.next = 8;
                        break;
                      case 7:
                        _this18.logger.error('booking invalid: ', booking);
                      case 8:
                      case "end":
                        return _context40.stop();
                    }
                  }, _callee40);
                }));
                return function (_x63, _x64) {
                  return _ref20.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context41.stop();
          }
        }, _callee41, this);
      }));
      function updateTraveler(_x62) {
        return _updateTraveler.apply(this, arguments);
      }
      return updateTraveler;
    }()
  }, {
    key: "updateTravelers",
    value: function () {
      var _updateTravelers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee43(travelers) {
        var _this19 = this;
        return _regeneratorRuntime().wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              _context43.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref21 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee42(booking, api) {
                  return _regeneratorRuntime().wrap(function _callee42$(_context42) {
                    while (1) switch (_context42.prev = _context42.next) {
                      case 0:
                        _this19.logger.log('updateTravelers', travelers);
                        if (!(booking && booking.id)) {
                          _context42.next = 7;
                          break;
                        }
                        _context42.next = 4;
                        return api.updateTravelers(booking.id, false, travelers);
                      case 4:
                        _this19.bookingValue = _context42.sent;
                        _context42.next = 8;
                        break;
                      case 7:
                        _this19.logger.error('booking invalid: ', booking);
                      case 8:
                      case "end":
                        return _context42.stop();
                    }
                  }, _callee42);
                }));
                return function (_x66, _x67) {
                  return _ref21.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context43.stop();
          }
        }, _callee43, this);
      }));
      function updateTravelers(_x65) {
        return _updateTravelers.apply(this, arguments);
      }
      return updateTravelers;
    }()
  }, {
    key: "removeTraveler",
    value: function () {
      var _removeTraveler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee45(traveler) {
        var _this20 = this;
        return _regeneratorRuntime().wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              _context45.next = 2;
              return this.apiCallWithBooking(/*#__PURE__*/function () {
                var _ref22 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee44(booking, api) {
                  return _regeneratorRuntime().wrap(function _callee44$(_context44) {
                    while (1) switch (_context44.prev = _context44.next) {
                      case 0:
                        _this20.logger.log('removeTraveler', traveler);
                        if (!(booking && booking.id)) {
                          _context44.next = 7;
                          break;
                        }
                        _context44.next = 4;
                        return api.removeTraveler(booking.id, false, traveler);
                      case 4:
                        _this20.bookingValue = _context44.sent;
                        _context44.next = 8;
                        break;
                      case 7:
                        _this20.logger.error('booking invalid: ', booking);
                      case 8:
                      case "end":
                        return _context44.stop();
                    }
                  }, _callee44);
                }));
                return function (_x69, _x70) {
                  return _ref22.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context45.stop();
          }
        }, _callee45, this);
      }));
      function removeTraveler(_x68) {
        return _removeTraveler.apply(this, arguments);
      }
      return removeTraveler;
    }()
  }, {
    key: "updateServiceNotes",
    value: function () {
      var _updateServiceNotes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee46(rq, attempt) {
        var response;
        return _regeneratorRuntime().wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              if (this.api) {
                _context46.next = 2;
                break;
              }
              throw new Error(this.ERR_NO_API);
            case 2:
              _context46.prev = 2;
              if (!rq) {
                _context46.next = 9;
                break;
              }
              _context46.next = 6;
              return this.api.updateServiceNotes(attempt, rq);
            case 6:
              response = _context46.sent;
              this.bookingValue = response;
              return _context46.abrupt("return", response);
            case 9:
              _context46.next = 14;
              break;
            case 11:
              _context46.prev = 11;
              _context46.t0 = _context46["catch"](2);
              this.logger.error('Update service notes failed');
            case 14:
              return _context46.abrupt("return", Promise.reject());
            case 15:
            case "end":
              return _context46.stop();
          }
        }, _callee46, this, [[2, 11]]);
      }));
      function updateServiceNotes(_x71, _x72) {
        return _updateServiceNotes.apply(this, arguments);
      }
      return updateServiceNotes;
    }()
  }, {
    key: "apiCall",
    value: function () {
      var _apiCall2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee47(_apiCall, throwError) {
        var errorResponse, errorBody;
        return _regeneratorRuntime().wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              if (this.api) {
                _context47.next = 2;
                break;
              }
              throw new Error(this.ERR_NO_API);
            case 2:
              // these are observables --> UI will "play" changes sequentially
              this.isBusyValue = true;
              _context47.prev = 3;
              _context47.next = 6;
              return _apiCall(this.api);
            case 6:
              this.hasErrorValue = false;
              this.errorResponse = null;
              _context47.next = 22;
              break;
            case 10:
              _context47.prev = 10;
              _context47.t0 = _context47["catch"](3);
              errorResponse = _context47.t0;
              console.error(errorResponse);
              if (!errorResponse.bodyUsed) {
                _context47.next = 20;
                break;
              }
              _context47.next = 17;
              return errorResponse.json();
            case 17:
              errorBody = _context47.sent;
              this.hasErrorValue = true;
              this.errorResponse = ApiErrorResponseFromJSON(errorBody);
            case 20:
              if (!throwError) {
                _context47.next = 22;
                break;
              }
              throw _context47.t0;
            case 22:
              _context47.prev = 22;
              this.isBusyValue = false;
              return _context47.finish(22);
            case 25:
            case "end":
              return _context47.stop();
          }
        }, _callee47, this, [[3, 10, 22, 25]]);
      }));
      function apiCall(_x73, _x74) {
        return _apiCall2.apply(this, arguments);
      }
      return apiCall;
    }()
  }, {
    key: "apiCallWithBooking",
    value: function () {
      var _apiCallWithBooking = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee49(apiCall, bookingId) {
        var _this21 = this;
        return _regeneratorRuntime().wrap(function _callee49$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              if (!(!this.bookingValue || !this.bookingValue.id)) {
                _context49.next = 3;
                break;
              }
              _context49.next = 3;
              return this.init(bookingId);
            case 3:
              return _context49.abrupt("return", this.apiCall(/*#__PURE__*/function () {
                var _ref23 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee48(api) {
                  return _regeneratorRuntime().wrap(function _callee48$(_context48) {
                    while (1) switch (_context48.prev = _context48.next) {
                      case 0:
                        return _context48.abrupt("return", apiCall(_this21.booking, api));
                      case 1:
                      case "end":
                        return _context48.stop();
                    }
                  }, _callee48);
                }));
                return function (_x77) {
                  return _ref23.apply(this, arguments);
                };
              }()));
            case 4:
            case "end":
              return _context49.stop();
          }
        }, _callee49, this);
      }));
      function apiCallWithBooking(_x75, _x76) {
        return _apiCallWithBooking.apply(this, arguments);
      }
      return apiCallWithBooking;
    }()
  }, {
    key: "getItem",
    value: function getItem(itemId) {
      if (this.booking) {
        var parentItem = this.booking.items.find(function (item) {
          return item.id === itemId;
        });
        if (parentItem) {
          return parentItem;
        }
      }
      return null;
    }
  }, {
    key: "getHotels",
    value: function getHotels() {
      var hotels = [];
      if (this.booking) {
        this.booking.bookedItems.forEach(function (item) {
          if (ApiItemType.HOTEL === item.itemType) {
            hotels.push(item);
          }
        });
      }
      return hotels;
    }
  }, {
    key: "makeNewsletterSubscription",
    value: function () {
      var _makeNewsletterSubscription = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee50(newsletterSubscriptionRequest) {
        return _regeneratorRuntime().wrap(function _callee50$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              if (!(this.booking && this.api)) {
                _context50.next = 14;
                break;
              }
              _context50.prev = 1;
              _context50.next = 4;
              return this.api.newsletterSubscription(newsletterSubscriptionRequest);
            case 4:
              return _context50.abrupt("return", _context50.sent);
            case 7:
              _context50.prev = 7;
              _context50.t0 = _context50["catch"](1);
              _context50.t1 = ApiErrorResponseFromJSON;
              _context50.next = 12;
              return _context50.t0.json();
            case 12:
              _context50.t2 = _context50.sent;
              this.errorResponse = (0, _context50.t1)(_context50.t2);
            case 14:
              return _context50.abrupt("return", Promise.reject());
            case 15:
            case "end":
              return _context50.stop();
          }
        }, _callee50, this, [[1, 7]]);
      }));
      function makeNewsletterSubscription(_x78) {
        return _makeNewsletterSubscription.apply(this, arguments);
      }
      return makeNewsletterSubscription;
    }()
  }, {
    key: "initPackageCart",
    value: function () {
      var _initPackageCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee52(packageId, bookingId, packageCartId) {
        var _this22 = this;
        return _regeneratorRuntime().wrap(function _callee52$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              _context52.next = 2;
              return this.apiCall(/*#__PURE__*/function () {
                var _ref24 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee51(api) {
                  var cart;
                  return _regeneratorRuntime().wrap(function _callee51$(_context51) {
                    while (1) switch (_context51.prev = _context51.next) {
                      case 0:
                        _context51.next = 2;
                        return api.start(packageId, bookingId, true, packageCartId);
                      case 2:
                        cart = _context51.sent;
                        runInAction(function () {
                          if (!!cart) {
                            _this22._packageCart = cart;
                          }
                        });
                      case 4:
                      case "end":
                        return _context51.stop();
                    }
                  }, _callee51);
                }));
                return function (_x82) {
                  return _ref24.apply(this, arguments);
                };
              }(), true);
            case 2:
              return _context52.abrupt("return", _context52.sent);
            case 3:
            case "end":
              return _context52.stop();
          }
        }, _callee52, this);
      }));
      function initPackageCart(_x79, _x80, _x81) {
        return _initPackageCart.apply(this, arguments);
      }
      return initPackageCart;
    }()
  }, {
    key: "loadPackageCart",
    value: function () {
      var _loadPackageCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee54(packageCartId) {
        var _this23 = this;
        return _regeneratorRuntime().wrap(function _callee54$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              _context54.next = 2;
              return this.apiCall(/*#__PURE__*/function () {
                var _ref25 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee53(api) {
                  var cart;
                  return _regeneratorRuntime().wrap(function _callee53$(_context53) {
                    while (1) switch (_context53.prev = _context53.next) {
                      case 0:
                        _context53.next = 2;
                        return api.load(packageCartId);
                      case 2:
                        cart = _context53.sent;
                        runInAction(function () {
                          if (!!cart) {
                            _this23._packageCart = cart;
                          }
                        });
                      case 4:
                      case "end":
                        return _context53.stop();
                    }
                  }, _callee53);
                }));
                return function (_x84) {
                  return _ref25.apply(this, arguments);
                };
              }(), true);
            case 2:
              return _context54.abrupt("return", _context54.sent);
            case 3:
            case "end":
              return _context54.stop();
          }
        }, _callee54, this);
      }));
      function loadPackageCart(_x83) {
        return _loadPackageCart.apply(this, arguments);
      }
      return loadPackageCart;
    }()
  }, {
    key: "updatePackageCartBooking",
    value: function () {
      var _updatePackageCartBooking = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee56() {
        var _this24 = this;
        return _regeneratorRuntime().wrap(function _callee56$(_context56) {
          while (1) switch (_context56.prev = _context56.next) {
            case 0:
              _context56.next = 2;
              return this.apiCall(/*#__PURE__*/function () {
                var _ref26 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee55(api) {
                  var cart, booking;
                  return _regeneratorRuntime().wrap(function _callee55$(_context55) {
                    while (1) switch (_context55.prev = _context55.next) {
                      case 0:
                        if (!_this24._packageCart) {
                          _context55.next = 8;
                          break;
                        }
                        _context55.next = 3;
                        return api.attemptBooking(_this24._packageCart.id);
                      case 3:
                        cart = _context55.sent;
                        _context55.next = 6;
                        return api.getBooking(_this24._packageCart.bookingId);
                      case 6:
                        booking = _context55.sent;
                        runInAction(function () {
                          if (!!cart) {
                            _this24._packageCart = cart;
                          }
                          if (!!booking) {
                            _this24.bookingValue = booking;
                          }
                        });
                      case 8:
                      case "end":
                        return _context55.stop();
                    }
                  }, _callee55);
                }));
                return function (_x85) {
                  return _ref26.apply(this, arguments);
                };
              }(), true);
            case 2:
              return _context56.abrupt("return", _context56.sent);
            case 3:
            case "end":
              return _context56.stop();
          }
        }, _callee56, this);
      }));
      function updatePackageCartBooking() {
        return _updatePackageCartBooking.apply(this, arguments);
      }
      return updatePackageCartBooking;
    }()
  }, {
    key: "removeItemFromPackageCart",
    value: function () {
      var _removeItemFromPackageCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee58(componentId, removedItemId) {
        var _this25 = this;
        return _regeneratorRuntime().wrap(function _callee58$(_context58) {
          while (1) switch (_context58.prev = _context58.next) {
            case 0:
              _context58.next = 2;
              return this.apiCall(/*#__PURE__*/function () {
                var _ref27 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee57(api) {
                  var cart;
                  return _regeneratorRuntime().wrap(function _callee57$(_context57) {
                    while (1) switch (_context57.prev = _context57.next) {
                      case 0:
                        if (!_this25._packageCart) {
                          _context57.next = 5;
                          break;
                        }
                        _context57.next = 3;
                        return api.removeItem(_this25._packageCart.id, componentId, removedItemId);
                      case 3:
                        cart = _context57.sent;
                        runInAction(function () {
                          if (!!cart) {
                            _this25._packageCart = cart;
                          }
                        });
                      case 5:
                      case "end":
                        return _context57.stop();
                    }
                  }, _callee57);
                }));
                return function (_x88) {
                  return _ref27.apply(this, arguments);
                };
              }(), true);
            case 2:
              return _context58.abrupt("return", _context58.sent);
            case 3:
            case "end":
              return _context58.stop();
          }
        }, _callee58, this);
      }));
      function removeItemFromPackageCart(_x86, _x87) {
        return _removeItemFromPackageCart.apply(this, arguments);
      }
      return removeItemFromPackageCart;
    }()
  }, {
    key: "updateBusStations",
    value: function () {
      var _updateBusStations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee60(busStation) {
        var _this26 = this;
        return _regeneratorRuntime().wrap(function _callee60$(_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              _context60.next = 2;
              return this.apiCall(/*#__PURE__*/function () {
                var _ref28 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee59(api) {
                  var cart;
                  return _regeneratorRuntime().wrap(function _callee59$(_context59) {
                    while (1) switch (_context59.prev = _context59.next) {
                      case 0:
                        if (!_this26._packageCart) {
                          _context59.next = 5;
                          break;
                        }
                        _context59.next = 3;
                        return api.updateBusStations(_this26._packageCart.id, busStation);
                      case 3:
                        cart = _context59.sent;
                        runInAction(function () {
                          if (!!cart) {
                            _this26._packageCart = cart;
                          }
                        });
                      case 5:
                      case "end":
                        return _context59.stop();
                    }
                  }, _callee59);
                }));
                return function (_x90) {
                  return _ref28.apply(this, arguments);
                };
              }(), true);
            case 2:
              return _context60.abrupt("return", _context60.sent);
            case 3:
            case "end":
              return _context60.stop();
          }
        }, _callee60, this);
      }));
      function updateBusStations(_x89) {
        return _updateBusStations.apply(this, arguments);
      }
      return updateBusStations;
    }()
  }, {
    key: "removeItemsFromPackageCart",
    value: function () {
      var _removeItemsFromPackageCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee62(componentId, removedItemIds) {
        var _this27 = this;
        return _regeneratorRuntime().wrap(function _callee62$(_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              _context62.next = 2;
              return this.apiCall(/*#__PURE__*/function () {
                var _ref29 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee61(api) {
                  var cart;
                  return _regeneratorRuntime().wrap(function _callee61$(_context61) {
                    while (1) switch (_context61.prev = _context61.next) {
                      case 0:
                        if (!_this27._packageCart) {
                          _context61.next = 5;
                          break;
                        }
                        _context61.next = 3;
                        return api.removeItems(_this27._packageCart.id, componentId, {
                          removedItemIds: removedItemIds
                        });
                      case 3:
                        cart = _context61.sent;
                        runInAction(function () {
                          if (!!cart) {
                            _this27._packageCart = cart;
                          }
                        });
                      case 5:
                      case "end":
                        return _context61.stop();
                    }
                  }, _callee61);
                }));
                return function (_x93) {
                  return _ref29.apply(this, arguments);
                };
              }(), true);
            case 2:
              return _context62.abrupt("return", _context62.sent);
            case 3:
            case "end":
              return _context62.stop();
          }
        }, _callee62, this);
      }));
      function removeItemsFromPackageCart(_x91, _x92) {
        return _removeItemsFromPackageCart.apply(this, arguments);
      }
      return removeItemsFromPackageCart;
    }()
  }, {
    key: "selectItemsInPackageCart",
    value: function () {
      var _selectItemsInPackageCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee64(componentId, selectedItemsIds, bookingOptions) {
        var _this28 = this;
        return _regeneratorRuntime().wrap(function _callee64$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              _context64.next = 2;
              return this.apiCall(/*#__PURE__*/function () {
                var _ref30 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee63(api) {
                  var _this28$_packageCart, cart;
                  return _regeneratorRuntime().wrap(function _callee63$(_context63) {
                    while (1) switch (_context63.prev = _context63.next) {
                      case 0:
                        if (!_this28._packageCart) {
                          _context63.next = 5;
                          break;
                        }
                        _context63.next = 3;
                        return api.selectItems((_this28$_packageCart = _this28._packageCart) === null || _this28$_packageCart === void 0 ? void 0 : _this28$_packageCart.id, componentId, {
                          bookingOptions: bookingOptions,
                          selectedItemIds: selectedItemsIds
                        });
                      case 3:
                        cart = _context63.sent;
                        runInAction(function () {
                          if (!!cart) {
                            _this28._packageCart = cart;
                          }
                        });
                      case 5:
                      case "end":
                        return _context63.stop();
                    }
                  }, _callee63);
                }));
                return function (_x97) {
                  return _ref30.apply(this, arguments);
                };
              }(), true);
            case 2:
              return _context64.abrupt("return", _context64.sent);
            case 3:
            case "end":
              return _context64.stop();
          }
        }, _callee64, this);
      }));
      function selectItemsInPackageCart(_x94, _x95, _x96) {
        return _selectItemsInPackageCart.apply(this, arguments);
      }
      return selectItemsInPackageCart;
    }()
  }, {
    key: "updateSelectablePackageOffers",
    value: function updateSelectablePackageOffers(selectablePackageOffers) {
      this._selectablePackageOffers = selectablePackageOffers;
    }
  }, {
    key: "updateTravelerComponentsAssociations",
    value: function updateTravelerComponentsAssociations(travelerComponentsAssociations) {
      this._travelerComponentsAssociations = travelerComponentsAssociations;
    }
  }, {
    key: "updateComponents",
    value: function updateComponents(components) {
      this._components = components;
    }
  }, {
    key: "selectablePackageOffers",
    get: function get() {
      return this._selectablePackageOffers;
    }
  }, {
    key: "components",
    get: function get() {
      return this._components;
    }
  }, {
    key: "travelerComponentsAssociations",
    get: function get() {
      return this._travelerComponentsAssociations;
    }
  }, {
    key: "packageCart",
    get: function get() {
      return this._packageCart;
    }
  }, {
    key: "reloadComponents",
    value: function () {
      var _reloadComponents = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee66(request) {
        var _this29 = this;
        return _regeneratorRuntime().wrap(function _callee66$(_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              _context66.next = 2;
              return this.apiCall(/*#__PURE__*/function () {
                var _ref31 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee65(api) {
                  var _this29$_packageCart$, cart;
                  return _regeneratorRuntime().wrap(function _callee65$(_context65) {
                    while (1) switch (_context65.prev = _context65.next) {
                      case 0:
                        if (!(_this29._packageCart && _this29._packageCart.packageModel.packageDetails)) {
                          _context65.next = 5;
                          break;
                        }
                        _context65.next = 3;
                        return api.changeComponents(_this29._packageCart.id, (_this29$_packageCart$ = _this29._packageCart.packageModel.packageDetails) === null || _this29$_packageCart$ === void 0 ? void 0 : _this29$_packageCart$[0].id, request);
                      case 3:
                        cart = _context65.sent;
                        runInAction(function () {
                          if (!!cart) {
                            _this29._packageCart = cart;
                          }
                        });
                      case 5:
                      case "end":
                        return _context65.stop();
                    }
                  }, _callee65);
                }));
                return function (_x99) {
                  return _ref31.apply(this, arguments);
                };
              }(), true);
            case 2:
              return _context66.abrupt("return", _context66.sent);
            case 3:
            case "end":
              return _context66.stop();
          }
        }, _callee66, this);
      }));
      function reloadComponents(_x98) {
        return _reloadComponents.apply(this, arguments);
      }
      return reloadComponents;
    }()
  }], [{
    key: "getTraveler",
    value: function getTraveler(travellers, personId) {
      return travellers.find(function (traveler) {
        return traveler.id === personId;
      });
    }
  }]);
  return BookingService;
}();
__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [Array, String]), __metadata("design:returntype", Promise)], BookingService.prototype, "updateBookingItemSpecialRequest", null);
__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [Array]), __metadata("design:returntype", Promise)], BookingService.prototype, "loadSeatMaps", null);
__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], BookingService.prototype, "loadSeatMap", null);
__decorate([computed, __metadata("design:type", Object), __metadata("design:paramtypes", [])], BookingService.prototype, "seatMaps", null);

export { BookingService as default };
//# sourceMappingURL=BookingService.js.map
